import { Blocks, Database, KeyRound, Network, ShieldCheck, Users, Wallet, Zap } from "lucide-react";
import { SectionHeading, SECTION_CLASS } from "./SectionHeading";

const DIFFERENTIATORS = [
  {
    title: "Hosted RAG, agents and workflows",
    description: "Knowledge bases, agents and LangGraph workflows run on GenAICore and are called as a model name. No vector database or orchestration code to operate.",
    icon: Database,
  },
  {
    title: "Your own provider keys",
    description: "Connect your existing AWS Bedrock, Azure OpenAI, Google Gemini or OpenAI accounts. The provider bills you at your own rates, so you keep your cloud discounts.",
    icon: KeyRound,
  },
  {
    title: "Client accounts with your markup",
    description: "On Agency plans each client gets an account with its own wallet, API key and usage. Your markup is credited to your wallet on every client request.",
    icon: Users,
  },
  {
    title: "Prepaid, with a hard stop",
    description: "Every account pays from a prepaid wallet. At $0, model calls stop instead of running up a bill. Low-balance alerts warn you before that.",
    icon: Wallet,
  },
  {
    title: "Failover before the first byte",
    description: "Transient provider failures are retried, then the next model in your fallback chain is tried, before anything is streamed. Clients never get half an answer from two models.",
    icon: Network,
  },
  {
    title: "Semantic cache with visible savings",
    description: "Opt in per request and repeated questions are answered from the cache at a reduced price. The savings show up in your dashboard.",
    icon: Zap,
  },
  {
    title: "Three APIs, every provider",
    description: "OpenAI Chat Completions, OpenAI Responses and Anthropic Messages work with every provider, in the exact wire format the official SDKs expect.",
    icon: Blocks,
  },
  {
    title: "Audited settings",
    description: "Provider keys are stored encrypted, and every change to platform settings lands in an append-only audit trail.",
    icon: ShieldCheck,
  },
];

export function Differentiators() {
  return (
    <section id="features" className={SECTION_CLASS}>
      <SectionHeading
        eyebrow="Why GenAICore"
        title="Routing is a commodity."
        accent="The application layer is not."
        description="Model access is table stakes. GenAICore stores what you build and the client relationships you bill, so the same knowledge base, agent or workflow serves every client on any model."
        className="mb-12 sm:mb-16"
      />

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {DIFFERENTIATORS.map((item) => {
          const Icon = item.icon;
          return (
            <div key={item.title} className="rounded-card bg-card p-6 flex flex-col">
              <span className="h-10 w-10 rounded-xl bg-surface-muted flex items-center justify-center mb-8">
                <Icon className="h-5 w-5" strokeWidth={1.7} />
              </span>
              <h3 className="text-lg font-medium">{item.title}</h3>
              <p className="text-[15px] text-muted-foreground mt-2 leading-relaxed">{item.description}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
